// This is a custom error class that can be used in the application,
// so we can customize our error handling e.g in the error boundary fallback page
export default class AppError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AppError';
  }
}
